import { useMemo, useState } from "react";
import type { HardwareItemType } from "@/schemas/index";
import { ModalHardwareInstallControllerProps } from "../types/index";

export function useController({
  onFinish,
}: ModalHardwareInstallControllerProps = {}) {
  const [isOpenDrawer, setIsOpenDrawer] = useState<boolean>();
  const [hardwareItem, setHardwareItem] = useState<HardwareItemType>();

  const close = () => {
    setIsOpenDrawer(false);
  };

  const open = (hardwareItem: HardwareItemType) => {
    setHardwareItem({ ...hardwareItem });
    setIsOpenDrawer(true);
  };

  return useMemo(
    () => ({
      hardwareItem,
      isOpenDrawer,
      close,
      onFinish,
      open,
    }),
    [hardwareItem, isOpenDrawer, onFinish],
  );
}
